import { render, staticRenderFns } from "./FtthUncappedPricing.vue?vue&type=template&id=6aca3fb4&scoped=true&"
import script from "./FtthUncappedPricing.vue?vue&type=script&lang=js&"
export * from "./FtthUncappedPricing.vue?vue&type=script&lang=js&"
import style0 from "./FtthUncappedPricing.vue?vue&type=style&index=0&id=6aca3fb4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aca3fb4",
  null
  
)

export default component.exports